import { ApplicationState } from '@app/store'
import {
  ICurrentUserState,
  selectCurrentUser,
} from '@app/store/modules/account'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { SecureComponent } from '../components/SecureComponent'

export default connect(
  createStructuredSelector<ApplicationState, ICurrentUserState>({
    user: selectCurrentUser(),
  }),
)(SecureComponent)
